// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f941c1bc","396":"8f58d7a3","453":"10797dff","455":"9e4b44c5","857":"40df7558","977":"9e6e2771"}[chunkId] + ".chunk.js";
};